export default "__VITE_ASSET__BOeSXOvP__"